import type { RouteConfig } from 'vue-router'

import * as namesConfiguracion from './nombres/configuracion'
import * as namesInformes from './nombres/informes'
import * as namesMantenimiento from './nombres/mantenimiento'
import * as namesTransacciones from './nombres/transacciones'
import { buildBreadcrumb } from '@/@core/utils/router'
import permisosImportaciones, { RESOURCE_IMPORTACIONES } from '@/auth/permissions/modules/importacionesPg'

const { mantenimiento, configuracion, transacciones, informes } = permisosImportaciones

export default [
    /**
     * RUTAS DE MANTENIMIENTO
     */
    {
        path: '/importacion-pg/mantenimiento/impuestos/gestion-impuestos',
        name: namesMantenimiento.ROUTE_GESTION_IMPUESTOS,
        component: () => import('@pages/importacion-pg/mantenimiento/impuestos/GestionImpuestos.vue'),
        meta: {
            title: 'i18n:importaciones.subopciones.gestion_impuestos',
            resource: RESOURCE_IMPORTACIONES,
            action: mantenimiento.gestionImpuestos,
            breadcrumb: buildBreadcrumb(
                'a:importaciones.menu_title',
                'a:global.menu.mantenimiento',
                'importaciones.subopciones.gestion_impuestos'
            ),
        },
    },
    {
        path: '/importacion-pg/mantenimiento/regimen-aduanero/gestion-regimenes-aduaneros',
        name: namesMantenimiento.ROUTE_GESTION_REGIMENES_ADUANEROS,
        component: () => import('@pages/importacion-pg/mantenimiento/regimenAduanero/GestionRegimenAduanero.vue'),
        meta: {
            title: 'i18n:importaciones.subopciones.gestion_regimenes_aduaneros',
            resource: RESOURCE_IMPORTACIONES,
            action: mantenimiento.gestionRegimenesAduaneros,
            breadcrumb: buildBreadcrumb(
                'a:importaciones.menu_title',
                'a:global.menu.mantenimiento',
                'importaciones.subopciones.gestion_regimenes_aduaneros'
            ),
        },
    },
    {
        path: '/importacion-pg/mantenimiento/divisas/gestion-divisas',
        name: namesMantenimiento.ROUTE_GESTION_DIVISAS,
        component: () => import('@pages/importacion-pg/mantenimiento/divisas/GestionDivisas.vue'),
        meta: {
            title: 'i18n:importaciones.subopciones.gestion_divisas',
            resource: RESOURCE_IMPORTACIONES,
            action: mantenimiento.gestionDivisas,
            breadcrumb: buildBreadcrumb(
                'a:importaciones.menu_title',
                'a:global.menu.mantenimiento',
                'importaciones.subopciones.gestion_divisas'
            ),
        },
    },
    //#region Configuracion
    {
        path: '/importacion-pg/configuracion/niveles-aprobacion',
        name: namesConfiguracion.ROUTE_NIVEL_APROBACION_IMPORTACION,
        component: () => import('@pages/importacion-pg/configuracion/CrearNivelAprobacion.vue'),
        meta: {
            title: 'i18n:importaciones.subopciones.niveles_aprobacion',
            resource: RESOURCE_IMPORTACIONES,
            action: configuracion.nivelesAprobacion,
            breadcrumb: buildBreadcrumb(
                'a:importaciones.menu_title',
                'a:global.menu.configuracion',
                'importaciones.subopciones.niveles_aprobacion'
            ),
        },
    },
    {
        path: '/importacion-pg/configuracion/incoterms',
        name: namesConfiguracion.ROUTE_TERMINOS_NEGOCIACION,
        component: () => import('@pages/importacion-pg/configuracion/CrearTerminosNegociacion.vue'),
        meta: {
            title: 'i18n:importaciones.subopciones.terminos_negociacion',
            resource: RESOURCE_IMPORTACIONES,
            action: configuracion.incoterms,
            breadcrumb: buildBreadcrumb(
                'a:importaciones.menu_title',
                'a:global.menu.configuracion',
                'importaciones.subopciones.terminos_negociacion'
            ),
        },
    },
    //#endregion
    //#region Transacciones
    {
        path: '/importacion-pg/transacciones/requerimiento-importacion/:codigoImportacion?',
        name: namesTransacciones.ROUTE_CREAR_REQUERIMIENTO_IMP,
        component: () =>
            import('@pages/importacion-pg/transacciones/requerimientosImportaciones/CrearRequerimientoImportacion.vue'),
        meta: {
            title: 'i18n:importaciones.subopciones.crear_requerimiento',
            resource: RESOURCE_IMPORTACIONES,
            action: transacciones.crearRequerimiento,
            breadcrumb: buildBreadcrumb(
                'a:importaciones.menu_title',
                'a:global.menu.transacciones',
                'importaciones.subopciones.crear_requerimiento'
            ),
        },
    },
    {
        path: '/importacion-pg/transacciones/gestion/requerimientos',
        name: namesTransacciones.ROUTE_GESTION_REQUERIMIENTOS_IMP,
        component: () =>
            import(
                '@pages/importacion-pg/transacciones/requerimientosImportaciones/GestionRequerimientosImportacion.vue'
            ),
        meta: {
            title: 'i18n:importaciones.subopciones.gestion_requerimientos',
            resource: RESOURCE_IMPORTACIONES,
            action: transacciones.gestionRequerimiento,
            breadcrumb: buildBreadcrumb(
                'a:importaciones.menu_title',
                'a:global.menu.transacciones',
                'importaciones.subopciones.gestion_requerimientos'
            ),
        },
    },
    {
        path: '/importacion-pg/transacciones/bandeja-gasto-importacion',
        name: namesTransacciones.ROUTE_BANDEJA_GASTO_IMPORTACION,
        component: () => import('@pages/importacion-pg/transacciones/gastoImportacion/BandejaGastoImportacion.vue'),
        meta: {
            title: 'i18n:importaciones.subopciones.bandeja_gasto_importacion',
            resource: RESOURCE_IMPORTACIONES,
            action: transacciones.bandejaGastoImportacion,
            breadcrumb: buildBreadcrumb(
                'a:importaciones.menu_title',
                'a:global.menu.transacciones',
                'importaciones.subopciones.bandeja_gasto_importacion'
            ),
        },
    },
    {
        path: '/importacion-pg/transacciones/gasto-importacion/:numeroDocumento?',
        name: namesTransacciones.ROUTE_GASTO_IMPORTACION,
        component: () => import('@pages/importacion-pg/transacciones/GastoImportacion.vue'),
        meta: {
            title: 'i18n:importaciones.subopciones.gasto_importacion',
            resource: RESOURCE_IMPORTACIONES,
            action: transacciones.gastoImportacion,
            breadcrumb: buildBreadcrumb(
                'a:importaciones.menu_title',
                'a:global.menu.transacciones',
                'importaciones.subopciones.gasto_importacion'
            ),
        },
    },
    {
        path: '/importacion-pg/transacciones/gestion/aprobacion-requerimiento',
        name: namesTransacciones.ROUTE_BANDEJA_APROBACION_REQUERIMIENTO_IMP,
        component: () =>
            import('@/views/pages/importacion-pg/transacciones/bandejaAprobacion/BandejaAprobacionRequerimiento.vue'),
        meta: {
            title: 'i18n:importaciones.subopciones.aprobacion_requerimiento',
            resource: RESOURCE_IMPORTACIONES,
            action: transacciones.bandejaAprobacion,
            breadcrumb: buildBreadcrumb(
                'a:importaciones.menu_title',
                'a:global.menu.transacciones',
                'importaciones.subopciones.aprobacion_requerimiento'
            ),
        },
    },
    {
        path: '/importacion-pg/transacciones/pendientes-nacionalizar',
        name: namesTransacciones.ROUTE_BANDEJA_PENDIENTE_NACIONALIZAR,
        component: () => import('@pages/importacion-pg/transacciones/BandejaPendienteNacionalizar.vue'),
        meta: {
            title: 'i18n:importaciones.subopciones.bandeja_pendiente_nacionalizar',
            resource: RESOURCE_IMPORTACIONES,
            action: transacciones.bandejaPendienteNacionalizar,
            breadcrumb: buildBreadcrumb(
                'a:importaciones.menu_title',
                'a:global.menu.transacciones',
                'importaciones.subopciones.bandeja_pendiente_nacionalizar'
            ),
        },
    },
    {
        path: '/importacion-pg/transacciones/nacionalizacion-importacion/:codigoImportacion?',
        name: namesTransacciones.ROUTE_NACIONALIZACION_IMPORTACION,
        component: () =>
            import('@pages/importacion-pg/transacciones/nacionalizacionImportacion/NacionalizacionImportacion.vue'),
        meta: {
            title: 'i18n:importaciones.subopciones.nacionalizacion_importacion',
            resource: RESOURCE_IMPORTACIONES,
            action: transacciones.nacionalizacionImportacion,
            breadcrumb: buildBreadcrumb(
                'a:importaciones.menu_title',
                'a:global.menu.transacciones',
                'importaciones.subopciones.nacionalizacion_importacion'
            ),
        },
    },
    {
        path: '/importacion-pg/transacciones/gestion-distribucion-importacion',
        name: namesTransacciones.ROUTE_GESTION_DISTRIBUCION_IMPORTACION,
        component: () => import('@pages/importacion-pg/transacciones/GestionDistribucionImportacion.vue'),
        meta: {
            title: 'i18n:importaciones.subopciones.gestion_distribucion_importacion',
            resource: RESOURCE_IMPORTACIONES,
            action: transacciones.bandejaDistribucionImportacion,
            breadcrumb: buildBreadcrumb(
                'a:importaciones.menu_title',
                'a:global.menu.transacciones',
                'importaciones.subopciones.gestion_distribucion_importacion'
            ),
        },
    },
    {
        path: '/importacion-pg/transacciones/distribucion-importacion/:codigoDocumento?',
        name: namesTransacciones.ROUTE_DISTRIBUCION_IMPORTACION,
        component: () => import('@pages/importacion-pg/transacciones/DistribucionImportacion.vue'),
        meta: {
            title: 'i18n:importaciones.subopciones.distribucion_importacion',
            resource: RESOURCE_IMPORTACIONES,
            action: transacciones.distribucionImportacion,
            breadcrumb: buildBreadcrumb(
                'a:importaciones.menu_title',
                'a:global.menu.transacciones',
                'importaciones.subopciones.distribucion_importacion'
            ),
        },
    },
    {
        path: '/importacion-pg/transacciones/recepcion-importacion',
        name: namesTransacciones.ROUTE_RECEPCION_IMPORTACION,
        component: () => import('@pages/importacion-pg/transacciones/RecepcionImportacion.vue'),
        meta: {
            title: 'i18n:importaciones.subopciones.recepcion_importacion',
            resource: RESOURCE_IMPORTACIONES,
            action: transacciones.recepcionImportacion,
            breadcrumb: buildBreadcrumb(
                'a:importaciones.menu_title',
                'a:global.menu.transacciones',
                'importaciones.subopciones.recepcion_importacion'
            ),
        },
    },
    {
        path: '/importacion-pg/transacciones/cierre-importacion',
        name: namesTransacciones.ROUTE_CIERRE_IMPORTACION,
        component: () => import('@pages/importacion-pg/transacciones/cierreImportacion/CierreImportacion.vue'),
        meta: {
            title: 'i18n:importaciones.subopciones.cierre_importacion',
            resource: RESOURCE_IMPORTACIONES,
            action: transacciones.cierreImportacion,
            breadcrumb: buildBreadcrumb(
                'a:importaciones.menu_title',
                'a:global.menu.transacciones',
                'importaciones.subopciones.cierre_importacion'
            ),
        },
    },
    {
        path: '/importacion-pg/transacciones/gestion-liquidacion',
        name: namesTransacciones.ROUTE_GESTION_LIQUIDACION_IMP,
        component: () =>
            import('@pages/importacion-pg/transacciones/liquidacionGastoImportacion/GestionLiquidacionImportacion.vue'),
        meta: {
            title: 'i18n:importaciones.subopciones.bandeja_liquidacion',
            resource: RESOURCE_IMPORTACIONES,
            action: transacciones.gestionLiquidacion,
            breadcrumb: buildBreadcrumb(
                'a:importaciones.menu_title',
                'a:global.menu.transacciones',
                'importaciones.subopciones.bandeja_liquidacion'
            ),
        },
    },
    {
        path: '/importacion-pg/transacciones/liquidacion-importacion/:idLiquidacion?',
        name: namesTransacciones.ROUTE_LIQUIDACION_IMPORTACION,
        component: () =>
            import('@pages/importacion-pg/transacciones/liquidacionGastoImportacion/LiquidacionImportacion.vue'),
        meta: {
            title: 'i18n:importaciones.subopciones.liquidacion_importacion',
            resource: RESOURCE_IMPORTACIONES,
            action: transacciones.liquidacionImportacion,
            breadcrumb: buildBreadcrumb(
                'a:importaciones.menu_title',
                'a:global.menu.transacciones',
                'importaciones.subopciones.liquidacion_importacion'
            ),
        },
    },
    {
        path: '/importacion-pg/transacciones/aprobacion-liquidacion',
        name: namesTransacciones.ROUTE_APROBACION_LIQUIDACION_IMP,
        component: () =>
            import(
                '@pages/importacion-pg/transacciones/liquidacionGastoImportacion/AprobacionLiquidacionImportacion.vue'
            ),
        meta: {
            title: 'i18n:importaciones.subopciones.aprobacion_liquidacion',
            resource: RESOURCE_IMPORTACIONES,
            action: transacciones.aprobacionLiquidacion,
            breadcrumb: buildBreadcrumb(
                'a:importaciones.menu_title',
                'a:global.menu.transacciones',
                'importaciones.subopciones.aprobacion_liquidacion'
            ),
        },
    },
    {
        path: '/importacion-pg/transacciones/revision-liquidacion/:idLiquidacion?',
        name: namesTransacciones.ROUTE_REVISION_LIQUIDACION,
        component: () =>
            import('@pages/importacion-pg/transacciones/liquidacionGastoImportacion/RevisionLiquidacion.vue'),
        meta: {
            title: 'i18n:importaciones.subopciones.revision_liquidacion',
            resource: RESOURCE_IMPORTACIONES,
            action: transacciones.revisionliquidacion,
            breadcrumb: buildBreadcrumb(
                'a:importaciones.menu_title',
                'a:global.menu.transacciones',
                'importaciones.subopciones.revision_liquidacion'
            ),
        },
    },
    {
        path: '/importacion-pg/transacciones/asignacion-gasto-importacion',
        name: namesTransacciones.ROUTE_ASIGNACION_GASTO_IMPORTACION,
        component: () => import('@pages/importacion-pg/transacciones/AsignacionGastoImportacion.vue'),
        meta: {
            title: 'i18n:importaciones.subopciones.asignacion_gasto_importacion',
            resource: RESOURCE_IMPORTACIONES,
            action: transacciones.asignacionGastoImportacion,
            breadcrumb: buildBreadcrumb(
                'a:importaciones.menu_title',
                'a:global.menu.transacciones',
                'importaciones.subopciones.asignacion_gasto_importacion'
            ),
        },
    },
    //#endregion
    //#region Informes
    {
        path: '/importacion-pg/informes/requerimiento-importaciones',
        name: namesInformes.ROUTE_INFORME_REQUERIMIENTO_IMPORTACIONES,
        component: () => import('@pages/importacion-pg/informes/InformeRequerimientoImportaciones.vue'),
        meta: {
            title: 'i18n:importaciones.subopciones.informe_requerimiento_importaciones',
            resource: RESOURCE_IMPORTACIONES,
            action: informes.requerimientoImportaciones,
            breadcrumb: buildBreadcrumb(
                'a:importaciones.menu_title',
                'a:global.menu.informes',
                'importaciones.subopciones.informe_requerimiento_importaciones'
            ),
        },
    },

    {
        path: '/importacion-pg/informes/resumen-liquidaciones-gastos',
        name: namesInformes.ROUTE_RESUMEN_LIQUIDACIONES_GASTOS,
        component: () => import('@pages/importacion-pg/informes/ResumenLiquidacionesGastos.vue'),
        meta: {
            title: 'i18n:importaciones.subopciones.resumen_liquidaciones_gastos',
            resource: RESOURCE_IMPORTACIONES,
            action: informes.resumenLiquidacionesGastos,
            breadcrumb: buildBreadcrumb(
                'a:importaciones.menu_title',
                'a:global.menu.informes',
                'importaciones.subopciones.resumen_liquidaciones_gastos'
            ),
        },
    },

    {
        path: '/importacion-pg/informes/derecho-arancelarios',
        name: namesInformes.ROUTE_DERECHO_ARANCELARIOS,
        component: () => import('@pages/importacion-pg/informes/DerechoArancelarios.vue'),
        meta: {
            title: 'i18n:importaciones.subopciones.derechos_arancelarios',
            resource: RESOURCE_IMPORTACIONES,
            action: informes.derechoArancelarios,
            breadcrumb: buildBreadcrumb(
                'a:importaciones.menu_title',
                'a:global.menu.informes',
                'importaciones.subopciones.derechos_arancelarios'
            ),
        },
    },
    //#endregion
] as RouteConfig[]
